<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Pricing Table" pageTitle="Pricing Table" />
            <PricingTable />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import PricingTable from '../PricingTable/PricingTable'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'InvoicePage',
    components: {
        MainHeader,
        PageTitle,
        PricingTable,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>